import styled from "styled-components";
import { black, white } from "../../utils/StyleHelpers";

export const StyledMainContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const StyledSubContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65.5625rem;
  flex-shrink: 0;
  border-radius: 1rem;
`;

export const ContextContainer = styled.div`
  margin-bottom: 1.5rem;
`;

export const Top = styled.div`
  width: 100%;
  height: 2rem;
  border-radius: 1rem 1rem 0 0;
  background: black;
`;

export const MovieTitle = styled.div`
  position: fixed;
  margin-top: 2rem;
  display: flex;
  width: 100%;
  margin-left: 1rem;
  flex-direction: column;
  justify-content: center;
  flex-shrink: 0;
  background: ${black};
  color: ${white};
  font-variant-numeric: stacked-fractions;
  font-feature-settings:
    "hlig" on,
    "dlig" on;
  font-family: Helvetica;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: 0%; /* 0rem */
  z-index: 9999;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const MovieWrapper = styled.div`
  border-radius: 1rem 1rem;
`;
